/**
 * 充电用户管理 接口
 */
import {
   deleteRequest,
   putRequest,
   getRequest,
   postRequest,
} from "../../utils/api";

export const apiListChargeUsers = (data) => {
   return postRequest('/api/charging-user/list?page='+data.page+'&size='+data.size, data)
}

export const apiUpdate = (data) => {
   return putRequest('/api/charging-user/update', data)
}

export const apiDelete = (data) => {
   return deleteRequest('/api/charging-user/delete'+id, data)
}
export const apiGet = (id) => {
   return getRequest('/api/charging-user/get/'+id)
}

export const apiListOrders = (data) => {
   return postRequest('/api/order/?page='+data.page+'&size='+data.size, data)
}

export const apiGetOrder = (id) => {
   return getRequest('/api/order/get/'+id)
}
